export const Messages = {
    validation: {
        isEmpty: "Please fill this field.",
        invalidPrice: "Please enter a valid price!",
        negativePrice: "Price can't be negative.",
        negativeQuantity: "Quantity can't be negative.",
        invalidQuantity: "Please enter a valid value.",
        negativeWeight: "Weight can't be negative.",
        zeroWeight: "Weight can't be zero.",
        invalidWeight: "Please enter a valid value.",
        isEmptyCategory: "Please select the category.",
        ouncesLimit: "Max 15 oz."
    },
    label: {
        imageSizeInfo: "Your product and collection images can be any size up to 4472 × 4472 px, or 20 megapixels. Product and collection images need to have a file size smaller than 10 MB to be added to Shopify.",
        image15Info: "JPG / PNG - max 15mb (15MP)",
    }
}